// src/App.tsx (FULLY UPDATED with all menu items)
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Dashboard from './pages/Dashboard.tsx';
import SignIn from './pages/auth/signin.tsx';
import SignUp from './pages/auth/signup.tsx';
import VerifyOTPSignin from './pages/auth/verifyotp_signin.tsx';
import VerifyOTPSignup from './pages/auth/verifyotp_signup.tsx';
import UserProfile from './pages/user_profile.tsx';
import Cart from './pages/cart.tsx';
import PaymentMethod from './pages/payment_method.tsx';
import ConfirmOrder from './pages/order_confirm.tsx';
import OrderPlaced from './pages/order_placed.tsx';
import PasswordAssistance from './pages/auth/reset_app_password/password_assistance.tsx';
import AP_Email_Verification from './pages/auth/reset_app_password/ap_email_verification.tsx';
import AP_Number_Verification from './pages/auth/reset_app_password/ap_number_verification.tsx';
import ResetNewPassword from './pages/auth/reset_app_password/reset_new_password.tsx';
import Product from './pages/product.tsx';
import ProductDetail from './pages/product_detail.tsx';
import StripeCheckout from './pages/static_stripe_checkout.tsx';
import ViewOrder from './pages/view_order.tsx';
import AdminDashboard from './pages/admin/adminDashboard.tsx';
import ManageProduct from './pages/admin/manageProductsList.tsx';
import Slidemenu from './components/admin/adminSlidemenu.tsx';
import AdminHeader from './components/admin/adminHeader.tsx';
import OrderManagement from './components/admin/adminSlidemenu.tsx';
import Addproduct from './pages/admin/addproduct.tsx';
import CategoryManagement from './pages/admin/catergoryManagement.tsx';
import Banner from './pages/admin/banner.tsx';
import SubBanner from './pages/admin/subBanner.tsx';
import DealOfTheDay from './pages/admin/dealoftheday.tsx';
import SmptSettings from './pages/admin/smtpsettings.tsx';
import SmsSettings from './pages/admin/smsSettings.tsx';
import UnitManagement from './pages/admin/unitManagement.tsx';
import AdminOrderManagement from './pages/admin/adminOrderManagement.tsx';
import SubCategoryManagement from './pages/admin/subCategoryMangement.tsx';
import Analytics from './pages/admin/analytics.tsx';
import PickupMessage from './pages/admin/pickupMessage.tsx';
import AdminLogin from './pages/admin/adminlogin.tsx';
import DeliveryManagement from './pages/admin/DeliveryManagement.tsx';
import ShippingManagement from './pages/admin/shippingManagement.tsx';
import ProductManagement from './pages/admin/productManagement.tsx';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReviewManagement from './pages/admin/review.tsx';
import SetCredit from './pages/admin/setCredit.tsx';
import GuestOrderList from './pages/admin/guestOrderlist.tsx';
import GuestUserOrder from './pages/admin/guestUserOrder.tsx';
import VendorLogin from './pages/admin/vendorlogin.tsx';
import UserList from './pages/admin/Userlist.tsx';
import FlashSale from './pages/admin/flashSale.tsx';
import Bundle from './pages/admin/bundle.tsx';
import DeliveryAgentManagement from './pages/admin/deliveryAgent.tsx';
import WareHoueManagement from './pages/admin/warehouseManagement.tsx';
import ProductWarehouseManagement from './pages/admin/ProductWarehouseManagement.tsx';
import CouponManagement from './pages/admin/couponManagement.tsx';
import RewardManagement from './pages/admin/RewardManagement.tsx';
import RewardSettingsManagement from './pages/admin/RewardSettingsManagement.tsx';
import AdminRewards from './pages/admin/AdminRewards.tsx';
import AdminCouponUsers from './pages/admin/AdminCouponUsers.tsx';
import Delivery from './pages/admin/deliverySettings.tsx';
import RegisterAdmin from './pages/admin/registeradmin.tsx';
import RoleMaster from './pages/admin/roleMaster.tsx';
import RoleMappingManagement from './pages/admin/roleMapping.tsx';
import AdminUserList from './pages/admin/adminUserList.tsx';
import PickupPending from './pages/admin/pickupPending.tsx';
import React from 'react';
import BulkOrderManagement from './pages/admin/bulkOrder.tsx';
import BundleManagement from './pages/admin/bundleManagement.tsx';
import ReturnProcessManagement from './pages/admin/returnProcessManagement.tsx';
import TaxSettings from './pages/admin/TaxSettings.tsx';
import SiteSettings from './pages/admin/SiteSettings.tsx';
import ReportsManagement from './pages/admin/ReportsManagement.tsx';
import ReportsList from './pages/admin/ReportsList.tsx';
import UserWallet from './pages/admin/UserWallet.tsx';
import ReferFriend from './pages/admin/ReferFriend.tsx';
import CareerManagement from './pages/admin/CareerManagement.tsx';
import MembershipPlanManagement from './pages/admin/MembershipPlanManagement.tsx';
import AgentDetails from './pages/admin/agentDetails.tsx';
import UserMonitor from './pages/admin/UserMonitor.tsx';
import ExtendedWarrantyManagement from './pages/admin/ExtendedWarrantyManagement.tsx';
import ExtWarrantyProductsList from './pages/admin/ExtWarrantyProductsList.tsx';
import GeneratedReports from './pages/admin/GeneratedReports.tsx';
import CashOnDelivery from './pages/admin/cashOnDelivery.tsx';
import AboutUsPage from './pages/admin/aboutus.tsx';
import ServicesPage from './pages/admin/service.tsx';
import SupportManagement from './pages/admin/SupportManagement.tsx';

// ------------------------------------------------------------
// Map each URL path to the required permission key
// (Must match ALL_MENUS ids from SlideMenu.tsx)
// ------------------------------------------------------------
const MENU_PATH_MAP: Record<string, string> = {
  // Regular Menus
  dashboard: "/adminDashboard",
  user_list: "/Userlist",
  order_management: "/adminOrderManagement",
  bulk_order_management: "/bulkOrderManagement",
  return_process_management: "/returnprocessManagement",
  ext_warranty_products: "/extWarrantyProducts",
  review: "/review",
  guest_order_list: "/guestOrderlist",
  guest_user_order: "/guestUserOrder",
  set_credit: "/SetCredit",
  pickupPending: "/pickupPending",
  deal_of_the_day: "/dealoftheday",
  reward_management: "/rewardManagement",
  reward_settings_management: "/RewardSettingsManagement",
  admin_rewards: "/AdminRewards",
  flash_sale: "/flashSale",
  delivery_settings: "/deliverySettings",
  tax_settings: "/taxSettings",
  reports_list: "/reportsList",
  user_wallet: "/userWallet",
  refer_friend: "/referFriend",
  agent_details: "/agentDetails",
  user_monitor: "/userMonitor",
  support_management: "/supportManagement",

  // Master Menus
  product_management: "/productManagement",
  bundle_management: "/bundleManagment",
  category_management: "/categoryManagement",
  subcategory_management: "/subcategorymanagement",
  unit_management: "/unitManagement",
  delivery_agent_management: "/DeliveryAgentManagement",
  warehouse_management: "/WarehouseManagement",
  banner_management: "/banner",
  product_warehouse_management: "/ProductWarehouseManagement",
  delivery_management: "/deliveryManagement",
  shipping_management: "/shippingManagement",
  extended_warranty: "/extendedWarranty",
  career_management: "/careerManagement",
  membership_plan_management: "/membershipPlanManagement",
  reports_management: "/reportsManagement",

  // Coupon Menus
  coupon_management: "/couponManagement",
  admin_coupon_users: "/AdminCouponUsers",

  // Admin Menus
  admin_user_list: "/adminUserList",
  role_master: "/roleMaster",
  role_mapping: "/roleMapping",

  // Global Settings Menus
  smtp_settings: "/smtpsettings",
  site_settings: "/siteSettings",
  cash_on_delivery: "/cashOnDelivery",
  about_us: "/aboutUsPage",
  services: "/servicePage",
};

// Invert to get path -> permission key
const PATH_PERMISSION_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(MENU_PATH_MAP).map(([key, path]) => [path, key])
);

// ------------------------------------------------------------
// ProtectedRoute – checks permissions from localStorage
// ------------------------------------------------------------
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  // 1. Check authentication
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // 2. Get user role (for super admin fallback)
  const userRole = (localStorage.getItem('admin_type') || '').toLowerCase();
  const isSuperAdmin = userRole.includes('super');

  // 3. Get permissions from storage
  let permissions: Record<string, any> = {};
  try {
    const stored = localStorage.getItem('admin_permissions');
    if (stored) {
      permissions = JSON.parse(stored);
    }
  } catch (e) {
    console.warn('Failed to parse permissions', e);
  }

  // 4. Determine required permission for this path
  const currentPath = location.pathname;
  const requiredKey = PATH_PERMISSION_MAP[currentPath];

  // 5. Decision: allow if super admin OR if the required key exists in permissions
  const hasPermission = isSuperAdmin || (requiredKey && permissions.hasOwnProperty(requiredKey));

  console.log(`🔒 ProtectedRoute: path=${currentPath}, requiredKey=${requiredKey}, hasPermission=${hasPermission}`);

  if (hasPermission) {
    return <>{children}</>;
  } else {
    return <Navigate to="/adminDashboard" replace />;
  }
};

// ------------------------------------------------------------
// AdminLayout – ensures user is logged in before rendering
// ------------------------------------------------------------
const AdminLayout = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem('admin_token');
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

// ------------------------------------------------------------
// Main App component
// ------------------------------------------------------------
function App() {
  return (
    <>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/" element={<AdminLogin />} />
          <Route path="/adminlogin" element={<AdminLogin />} />
          <Route path="/vendorlogin" element={<VendorLogin />} />

          <Route path="/customer/signin" element={<SignIn />} />
          <Route path="/customer/signup" element={<SignUp />} />
          <Route path="/customer/otp-verification-signin" element={<VerifyOTPSignin />} />
          <Route path="/customer/otp-verification-signup" element={<VerifyOTPSignup />} />
          <Route path="/customer/ap" element={<PasswordAssistance />} />
          <Route path="/customer/ap-email-verification" element={<AP_Email_Verification />} />
          <Route path="/customer/ap-number-verification" element={<AP_Number_Verification />} />
          <Route path="/customer/reset-ap" element={<ResetNewPassword />} />
          <Route path="/customer/my-account" element={<UserProfile />} />
          <Route path="/customer/cart" element={<Cart />} />
          <Route path="/customer/payment-method" element={<PaymentMethod />} />
          <Route path="/customer/confirm-order" element={<ConfirmOrder />} />
          <Route path="/customer/order-placed" element={<OrderPlaced />} />
          <Route path="/customer/view-order" element={<ViewOrder />} />
          <Route path="/customer/products" element={<Product />} />
          <Route path="/customer/product-detail" element={<ProductDetail />} />
          <Route path="/customer/stripe-checkout" element={<StripeCheckout />} />

          <Route path="/adminDashboard" element={
            <AdminLayout>
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/productManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <ProductManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/adminOrderManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <AdminOrderManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/bulkOrderManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <BulkOrderManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/bundleManagment" element={
            <AdminLayout>
              <ProtectedRoute>
                <BundleManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/returnprocessManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <ReturnProcessManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/Userlist" element={
            <AdminLayout>
              <ProtectedRoute>
                <UserList />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/taxSettings" element={
            <AdminLayout>
              <ProtectedRoute>
                <TaxSettings />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/categorymanagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <CategoryManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/unitmanagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <UnitManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/extendedWarranty" element={
            <AdminLayout>
              <ProtectedRoute>
                <ExtendedWarrantyManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/extWarrantyProducts" element={
            <AdminLayout>
              <ProtectedRoute>
                <ExtWarrantyProductsList />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/WarrantyManagement" element={
            <Navigate to="/extWarrantyProducts" replace />
          } />

          <Route path="/subcategorymanagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <SubCategoryManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/DeliveryAgentManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <DeliveryAgentManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/WarehouseManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <WareHoueManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/banner" element={
            <AdminLayout>
              <ProtectedRoute>
                <Banner />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/subbanner" element={
            <AdminLayout>
              <ProtectedRoute>
                <SubBanner />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/review" element={
            <AdminLayout>
              <ProtectedRoute>
                <ReviewManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/guestOrderlist" element={
            <AdminLayout>
              <ProtectedRoute>
                <GuestOrderList />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/guestUserOrder" element={
            <AdminLayout>
              <ProtectedRoute>
                <GuestUserOrder />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/SetCredit" element={
            <AdminLayout>
              <ProtectedRoute>
                <SetCredit />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/pickupPending" element={
            <AdminLayout>
              <ProtectedRoute>
                <PickupPending />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/ProductWarehouseManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <ProductWarehouseManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/dealoftheday" element={
            <AdminLayout>
              <ProtectedRoute>
                <DealOfTheDay />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/couponManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <CouponManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/AdminCouponUsers" element={
            <AdminLayout>
              <ProtectedRoute>
                <AdminCouponUsers />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/rewardManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <RewardManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/RewardSettingsManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <RewardSettingsManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/AdminRewards" element={
            <AdminLayout>
              <ProtectedRoute>
                <AdminRewards />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/flashSale" element={
            <AdminLayout>
              <ProtectedRoute>
                <FlashSale />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/deliveryManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <DeliveryManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/shippingManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <ShippingManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/deliverySettings" element={
            <AdminLayout>
              <ProtectedRoute>
                <Delivery />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/adminUserList" element={
            <AdminLayout>
              <ProtectedRoute>
                <AdminUserList />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/roleMaster" element={
            <AdminLayout>
              <ProtectedRoute>
                <RoleMaster />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/roleMapping" element={
            <AdminLayout>
              <ProtectedRoute>
                <RoleMappingManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/registerAdmin" element={
            <AdminLayout>
              <ProtectedRoute>
                <RegisterAdmin />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/smtpsettings" element={
            <AdminLayout>
              <ProtectedRoute>
                <SmptSettings />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/siteSettings" element={
            <AdminLayout>
              <ProtectedRoute>
                <SiteSettings />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/globalSettings" element={
            <Navigate to="/siteSettings" replace />
          } />

          <Route path="/smsSettings" element={
            <AdminLayout>
              <ProtectedRoute>
                <SmsSettings />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/manageproduct" element={
            <AdminLayout>
              <ProtectedRoute>
                <ManageProduct />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/addproduct" element={
            <AdminLayout>
              <ProtectedRoute>
                <Addproduct />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/analytics" element={
            <AdminLayout>
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/pickupmessage" element={
            <AdminLayout>
              <ProtectedRoute>
                <PickupMessage />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/bundle" element={
            <AdminLayout>
              <ProtectedRoute>
                <Bundle />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/adminHeader" element={
            <AdminLayout>
              <ProtectedRoute>
                <AdminHeader onToggleMenu={undefined} />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/slidemenu" element={
            <AdminLayout>
              <ProtectedRoute>
                <Slidemenu mobileOpen={false} onToggle={() => {}} />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/orderManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <OrderManagement mobileOpen={false} onToggle={() => {}} />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/reportsManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <ReportsManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/reportsList" element={
            <AdminLayout>
              <ProtectedRoute>
                <ReportsList />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/userWallet" element={
            <AdminLayout>
              <ProtectedRoute>
                <UserWallet />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/referFriend" element={
            <AdminLayout>
              <ProtectedRoute>
                <ReferFriend />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/generatedReports" element={
            <AdminLayout>
              <ProtectedRoute>
                <GeneratedReports />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/cashOnDelivery" element={
            <AdminLayout>
              <ProtectedRoute>
                <CashOnDelivery />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/aboutUsPage" element={
            <AdminLayout>
              <ProtectedRoute>
                <AboutUsPage />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/servicePage" element={
            <AdminLayout>
              <ProtectedRoute>
                <ServicesPage />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/careerManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <CareerManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/membershipPlanManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <MembershipPlanManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/agentDetails" element={
            <AdminLayout>
              <ProtectedRoute>
                <AgentDetails />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/userMonitor" element={
            <AdminLayout>
              <ProtectedRoute>
                <UserMonitor />
              </ProtectedRoute>
            </AdminLayout>
          } />

          <Route path="/supportManagement" element={
            <AdminLayout>
              <ProtectedRoute>
                <SupportManagement />
              </ProtectedRoute>
            </AdminLayout>
          } />
        </Routes>
      </Router>
    </>
  );
}

export default App;